//------------------------------------------------------
//	上部750Px写真用owl-carousel
//------------------------------------------------------
$(document).ready(function(){
	if( pluginExists( "owlCarousel" ) ){
		$('#owl').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 1, //10 items above 1000px browser width
					}
			},
			stagePadding: 200,
			center:true,
			lazyLoad: true,
			autoplay: true, //Set AutoPlay to 3 seconds
			autoplayTimeout: 3000, //Set AutoPlay to 3 seconds
			margin:10,
			loop:true
		});

		//#owlは一番上に表示されるものなので、問題ないようにロード
		var mycarousel = $('#owl');
		mycarousel.on('loaded.owl.lazy', function(event) {
			$('#owl').find('img').each(function(){
//				console.log($(this).data('src'));
				$(this).css("opacity", "1");
				$(this).attr('src',$(this).data('src'));
			});
		});


		//items数3個用
		$('.owl3').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 3, //10 items above 1000px browser width
					}
			},
			autoplay:true,
			autoplayTimeout:3000,
			autoplaySpeed:1000,
			autoplayHoverPause:true,
			lazyLoad: true,
			margin:10,
			loop:true
		});

		//items数4個用
		$('.owl4').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 4, //10 items above 1000px browser width
					},
			},
			lazyLoad: true,
			autoplay:true,
			autoplayTimeout:3000,
			autoplaySpeed:1000,
			autoplayHoverPause:true,
			dots:false,
			center:true,
			margin:10,
			loop:true
		});

		//items数5個用
		$('.owl5').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 5, //10 items above 1000px browser width
					}
			},
			lazyLoad: true,
			autoplay:true,
			autoplayTimeout:3000,
			autoplaySpeed:1000,
			autoplayHoverPause:true,
			dots:false,
			center:true,
			margin:10,
			loop:true
		});

		//items数7個用
		$('.owl7').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 7, //10 items above 1000px browser width
					}
			},
			lazyLoad: true,
			autoplay:true,
			autoplayTimeout:3000,
			autoplaySpeed:1000,
			autoplayHoverPause:true,
			dots:false,
			center:true,
			margin:10,
			loop:true
		});

		//ランキング用
		$('.owl4ranking').owlCarousel({
			responsive : {
					// breakpoint from 0 up
					0 : {
						items : 7, //10 items above 1000px browser width
					}
			},
			lazyLoad: true,
			slideBy:'page',
			stagePadding: 50,
			dots:false,
			margin:10,
			loop:true,
			nav:true,
			navText: ["",""]
		});
	}



});
